import PaymentComponent from '@/components/Pages/Payment.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/company/:companyId/folder/:folderId/payment',
  props: true,
  name: RouteNames.Payment,
  component: PaymentComponent,
};

export default route;
